window.ParsleyConfig = {
    errorsContainer: function (Field) {
        var $errorWrapper = $(Field.element).closest('.field-wrapper');
        if ($errorWrapper.length) {
            return $errorWrapper;
        }
    }
}
